<aside
    class="lyrics-chat-drawer"
    [class.open]="open"
    [attr.aria-hidden]="!open"
    aria-label="Lyrics assistant">
    <header class="chat-header">
        <div class="chat-quota" *ngIf="getLyricsQuotaLabel() as quotaLabel">
            {{ quotaLabel }}
        </div>
        <button
            type="button"
            aria-label="Close lyrics assistant"
            (click)="closeDrawer()">
            &times;
        </button>
    </header>

    <div class="chat-messages" #messagesContainer>
        <div class="chat-empty" *ngIf="messages.length === 0">
            <img
                src="assets/img/navbar/generative_sparkles.svg"
                alt=""
                aria-hidden="true" />
            <div>What should the lyrics be about?</div>
        </div>

        <div
            *ngFor="let message of messages"
            class="chat-message"
            [class.user-message]="message.role === 'user'"
            [class.assistant-message]="message.role === 'assistant'"
            [class.failed]="message.status === 'error'">
            <pre *ngIf="message.content">{{ message.content }}</pre>
            <div
                class="thinking-indicator"
                *ngIf="message.status === 'streaming' && !message.content"
                aria-label="Generating lyrics">
                Thinking
            </div>
            <button
                *ngIf="
                    message.role === 'assistant' &&
                    message.status === 'complete'
                "
                type="button"
                class="use-lyrics-button"
                (click)="applyLyrics(message.content)">
                Use these lyrics
            </button>
        </div>
    </div>

    <div class="chat-error" role="alert" *ngIf="errorMessage">
        <span>{{ errorMessage }}</span>
        <button type="button" (click)="retry()" [disabled]="generating">
            Retry
        </button>
    </div>

    <div class="chat-composer">
        <textarea
            [(ngModel)]="composerValue"
            [disabled]="generating || lyricsQuotaReached"
            maxlength="5000"
            rows="3"
            aria-label="Message the lyrics assistant"
            placeholder="Describe the lyrics you want..."
            (keydown)="onComposerKeydown($event)"></textarea>
        <button
            type="button"
            aria-label="Send message"
            [disabled]="generating || !composerValue.trim() || lyricsQuotaReached"
            (click)="sendMessage()">
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 19V5M6.5 10.5 12 5l5.5 5.5" />
            </svg>
        </button>
    </div>
</aside>
